import { Maybe } from "@ispb/react-hooks"
import { LazyContext } from "@ispb/react-lazy"
import { ReactNode } from "react"
import { Container } from "react-bootstrap"
import { ErrorBoundary } from "react-error-boundary"
import PageTitle from "ui/components/PageTitle"
import { FLUID_AT } from "ui/config"
import { Break } from "ui/index"
import { INTERNAL_FULL_PAGE_LAZY } from "ui/lazy/index"
import Boundary from "./Boundary.js"

export interface InternalLayoutProps {

    readonly title?: ReactNode | undefined
    readonly subtitle?: ReactNode | undefined
    readonly flex?: Break | undefined
    readonly actions?: ReactNode | undefined
    readonly children?: ReactNode | undefined

}

export default function Layout(props: InternalLayoutProps) {
    return (
        <ErrorBoundary FallbackComponent={Boundary}>
            <Container fluid={FLUID_AT} className="d-flex flex-column flex-grow-1">
                <LazyContext.Provider value={INTERNAL_FULL_PAGE_LAZY}>
                    <Maybe value={props.title} children={title => <PageTitle title={title} subtitle={props.subtitle} flex={props.flex} children={props.actions} />} />
                    <div className="d-flex flex-column flex-grow-1">
                        {props.children}
                    </div>
                </LazyContext.Provider>
            </Container>
        </ErrorBoundary>
    )
}
